import PaymentConfirmedBanner from './PaymentConfirmedBanner';

export default PaymentConfirmedBanner;
